/**
 * Ruta "Campo" (`/field`): bandeja de salida y paquete de campo para
 * trabajar sin señal. La ven quienes capturan en campo: gestores de cobro y
 * asesores.
 */
import { createFileRoute } from '@tanstack/react-router'
import { FieldPage } from '@/features/field/field-page'
import { FIELD_WORK_PERMISSION } from '@/lib/navigation'
import { requirePermission } from '@/lib/route-guards'

/** Trabajo de campo sin conexión. */
export const Route = createFileRoute('/_app/field')({
  beforeLoad: requirePermission(FIELD_WORK_PERMISSION),
  component: FieldPage,
})
